const imageDebounces = new WeakMap<HTMLImageElement, number>();

const getOriginalSrc = (img: HTMLImageElement) =>
	img.getAttribute("data-src") || img.getAttribute("src");

const swapImage = (img: HTMLImageElement, newSrc: string) => {
	if (!img.getAttribute("data-eimageswaporiginal")) {
		img.setAttribute("data-eimageswaporiginal", getOriginalSrc(img));
	}
	img.setAttribute("src", newSrc);
};

const restoreImage = (img: HTMLImageElement) => {
	const original = img.getAttribute("data-eimageswaporiginal");
	if (original && img.getAttribute("src") !== original) {
		img.setAttribute("src", original);
	}
};

const setupImageSwap = (img: HTMLImageElement) => {
	if (img.hasAttribute("data-eimageswap-init")) return;
	img.setAttribute("data-eimageswap-init", "");

	img.addEventListener("mouseenter", () => {
		const swapSrc = img.getAttribute("data-eimageswap");
		if (!swapSrc) return;

		swapImage(img, swapSrc);
	});

	img.addEventListener("mouseleave", () => {
		restoreImage(img);
	});
};

const getTargetImage = (scopeElement: HTMLElement, targetSelector: string) =>
	scopeElement.querySelector(targetSelector) as HTMLImageElement | null;

const setupTriggerSwap = (
	trigger: HTMLElement,
	scopeElement: HTMLElement,
	targetSelector: string
) => {
	if (trigger.hasAttribute("data-eimageswap-init")) return;
	trigger.setAttribute("data-eimageswap-init", "");

	trigger.addEventListener("mouseenter", () => {
		const targetImage = getTargetImage(scopeElement, targetSelector);
		const swapSrc = trigger.getAttribute("data-eimageswap");
		if (!targetImage || !swapSrc) return;

		window.clearTimeout(imageDebounces.get(targetImage));
		swapImage(targetImage, swapSrc);
	});

	trigger.addEventListener("mouseleave", () => {
		const targetImage = getTargetImage(scopeElement, targetSelector);
		if (!targetImage) return;

		imageDebounces.set(
			targetImage,
			window.setTimeout(() => restoreImage(targetImage), 250)
		);
	});
};

export default (scopeSelector?: string, targetSelector?: string) => {
	document.querySelectorAll("img[data-eimageswap]").forEach((img: HTMLImageElement) => {
		setupImageSwap(img);
	});

	if (!scopeSelector || !targetSelector) return;

	document.querySelectorAll("[data-eimageswap]:not(img)").forEach((trigger: HTMLElement) => {
		const scopeElement = trigger.closest(scopeSelector) as HTMLElement | null;
		if (!scopeElement) return;

		setupTriggerSwap(trigger, scopeElement, targetSelector);
	});
};
